import { render } from "./HeroTags.vue?vue&type=template&id=6ae0afd2&scoped=true"
import script from "./HeroTags.vue?vue&type=script&lang=js"
export * from "./HeroTags.vue?vue&type=script&lang=js"

import "./HeroTags.vue?vue&type=style&index=0&id=6ae0afd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae0afd2"]])

export default __exports__